import React               from "react"
import {useTranslation}    from "react-i18next"

import ItemNotFound from "../common/Items/ItemNotFound"
import IconPersonGroup from "../common/Icons/PersonGroup";

const NotFound: React.FC = () => {

    const { t } = useTranslation()

    const link: string = '/person-groups'

    return (
        <ItemNotFound icon={<IconPersonGroup link={link} size="large" />}
                      link={link}
                      subTitle={t('common.item_not_found', {
                          itemType: t('person-groups.title_item').toLowerCase() }
                      )} />
    )
}

export default NotFound